import ContentWrapperVue from '@/generic/components/ContentWrapper.vue';
import { computed, defineComponent } from 'vue';
import PageVue from '@/report/components/Page.vue';
import { useI18n } from 'vue-i18n';
import i18n from '@/i18n';

export default defineComponent({
    components: {
        Page: PageVue,
        ContentWrapper: ContentWrapperVue,
    },
    props: {
        categoryKey: { type: String },
        context: { type: String },
        scores: { type: Object },
        type: { type: String },
    },
    setup() {
        const { t } = useI18n();

        const color = computed(() => {
            return (data: number) => {
                let color = '';
                const colors = {
                    0: 'red',
                    61: 'orange',
                    76: 'light-green',
                    86: 'green',
                };

                Object.keys(colors).forEach((key: string) => {
                    if (data >= +key) {
                        color = colors[key];
                    }
                });
                return color;
            };
        });

        const distribution = (data: string) => {
            const colors = {
                LOW: 'green',
                MEDIUM: 'orange',
                MID: 'orange',
                HIGH: 'red',
            };

            return colors[data.toUpperCase()];
        };

        const translateTitle = (key: string) => {
            const parts = key.split(':');

            if (parts.length < 2) {
                return key;
            }

            if (parts[0] === 'default_country') {
                return `${t('demographics.question.' + parts[0])}:${getCountryTranslation(parts[1])}`;
            }

            if (parts[0] === 'open_question' || parts[0] === 'open') {
                return `${t('demographics.question.' + parts[0])}:${parts[1]}`;
            }

            return `${t('demographics.question.' + parts[0])}:${t('demographics.answer.' + parts[1])}`;
        };

        const getCountryTranslation = (countryCode: string): string => {
            const regionNames = new Intl.DisplayNames([i18n.global.locale], { type: 'region' });
            return regionNames.of(countryCode.toUpperCase());
        };

        return {
            color,
            distribution,
            translateTitle,
        };
    },
});
